<template>
    <div :style="style" ref="lottieAnimContainer"></div>
</template>

<script>
    import lottie from 'lottie-web';

    export default {
        name: 'lottie',
        props: {
            options: {
                type: Object, required: true, default: () => {
                    return {
                        animationData: {},
                        loop: true,
                        autoplay: true,
                        rendererSettings: {}
                    };
                }
            },
            height: { type: Number, default: 20 },
            width: { type: Number, default: 20 }
        },
        data() {
            return {
                style: {
                    width: this.width ? `${this.width}px` : '100%',
                    height: this.height ? `${this.height}px` : '100%',
                    overflow: 'hidden',
                    margin: '0 auto'
                },
                anim: {}
            }
        },
        mounted() {
            this.anim = lottie.loadAnimation({
                container: this.$refs.lottieAnimContainer,
                renderer: 'svg',
                loop: this.options.loop !== false,
                autoplay: this.options.autoplay !== false,
                animationData: this.options.animationData,
                rendererSettings: this.options.rendererSettings
            });
            this.$emit('animation', this.anim)
        }
    };
</script>